var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.125732,
    width: 29.9697,
    height: 23,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0232558 0.030303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 43,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAhCAYAAABAxlKmAAADOklEQVRYR+2Y/UtTYRTHv0O30s0fDN+DpBdfyozQLF1aJmYqFaRzm9NlPwRFBFFQUH9ABEL9B5HNORXNt35Kl2ZFEZlzvhaZ+dYPSZtNplvgFs+Ve3POzbvNqws8Pz6c55zPPc9zvufh8ux2ux3/ifG2YDk6KYfK/pyZwdfRbxylYhd2m2AbUlMOr+rsANv9+i0eV1Wzi8qR147QUDysvL8Fu+719aqyPB4PmeJ0yEqKIRIJ1x2KDtir00NVUwuDwUgteQVLBwsJEaFUKoE449i6AhuNs6jW1KHnk84hrk+wdKT9iQm4pFQgMjLCJ2gyg7Qvu9DQ1AqLxeIUyytYYXAwYmN3YWh4hAnI5/NxrjAfhQV5CAwM9Bh6fGIST56qMfZ9nNkbFLQde/fsxsDgsPfXgP7Cd+8/QFPXANPcHJMgJjoKFUoFEuLjWAFbrVY8a2lDe0cnbDYbsyftSArK5FLo+wcYyfSqsss3mefn0dDYjK7uN6CfEqQBszLFkEkuQCh03YC6vn6o1LX4ZTAwkOFhYVCWyXEoOYlaW67vPsPSWch0q1LVYHJqmklMNaBMAnG6YwPOzv6mGuhjTy/jGxAQgIIzp3H+bCEEAj6zzgksib64aMOLDi2aW5/Dav3DJEw6kIiL5QpEhIdB2/kKjU0tWFj410DxcftQoSzFzpgYp6vDGSydiRyrSl0HXZ/eoQEjI8IxNf2DWSMaLZUUIet4BsjVWc04h6WTEp1Ua+phMC6J+nKjhoq0GCEikdtG3DBYQmGxWtHU3IZ27VK3R0ctqUViAju12FBYumwTk1OULufmZHukwyOfv1CKQCxYKER5qXTVk3D5RHQnIazElQOnLVgOikqF3NTKksHR26fHqZNZrL5vU2HJM/HWnXvU6M3JPrEm8KbD3rx9l4IsV8goFXFnfgNLIBXyEuTl5rjk9StYQimXFiM/L9cznV3zArlxWKnRDyofgQg/W5OVFFGvs5XGyX8DX2EJ5LUrl3E0LdWB1y9hkw8m4cb1q04j2+n30ejoGNvTcuknEAgcfgENDo3AZDI5+ZvNZlRr6h3WXYE6DQWfKT0MQHSWli6y1R2oX8GuBUpg/wKru0i8OluqFQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailSent);
export default __webpack_public_path__ + "static/media/IconEmailSent.ba276cc7b3d2bcc8a6a1ee03819b8c77.svg";
export { ForwardRef as ReactComponent };